enum FilePreview {
  None,
  Client,
  Server,
}

type Capability = {
  preview: FilePreview;
  editable: boolean;
};

const FILE_CAPABILITIES: Record<string, Capability> = {
  jpg: { preview: FilePreview.Client, editable: false },
  jpeg: { preview: FilePreview.Client, editable: false },
  png: { preview: FilePreview.Client, editable: false },
  pdf: { preview: FilePreview.Server, editable: false },
  odt: { preview: FilePreview.Server, editable: false },
  ods: { preview: FilePreview.Server, editable: false },
  doc: { preview: FilePreview.Server, editable: true },
  docx: { preview: FilePreview.Server, editable: true },
  rtf: { preview: FilePreview.Server, editable: true },
  xls: { preview: FilePreview.None, editable: true },
  xlsx: { preview: FilePreview.None, editable: true },
};

export const ALL_FILE_TYPES = Object.keys(FILE_CAPABILITIES);

export const CLIENT_PREVIEW_FILE_TYPES = Object.entries(FILE_CAPABILITIES)
  .filter(([_, capability]) => capability.preview === FilePreview.Client)
  .map(([type]) => type);

export const SERVER_PREVIEW_FILE_TYPES = Object.entries(FILE_CAPABILITIES)
  .filter(([_, capability]) => capability.preview === FilePreview.Server)
  .map(([type]) => type);

export const PREVIEW_FILE_TYPES = [...CLIENT_PREVIEW_FILE_TYPES, ...SERVER_PREVIEW_FILE_TYPES];

export const EDITABLE_FILE_TYPES = Object.entries(FILE_CAPABILITIES)
  .filter(([_, capability]) => capability.editable)
  .map(([type]) => type);

export const MAX_FILE_SIZE_MB = 50;

export const MAX_FILE_SIZE = 1024 * 1024 * MAX_FILE_SIZE_MB;
